import React, { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import VelavuInput from "../../elements/velavu-input";
import OnboardingFrame from "./onboarding-frame";
import { OnboardingFrameProps } from "./onboarding-shared-data";
import { useSignInContext } from "../sign-in-context/sign-in-context";

interface OnboardingStepOrganizationProps extends OnboardingFrameProps {
	organization: string | undefined;
	setOrganization: (organization: string) => void;
}

export default function OnboardingStepOrganization(
	props: OnboardingStepOrganizationProps,
) {
	const { t } = useTranslation();
	const {
		navigateBackwards,
		navigateForwards,
		organization: propsOrganization,
		setOrganization: propsSetOrganization,
	} = props;

	const [organizationName, setOrganizationName] = useState("");
	useEffect(() => {
		setOrganizationName(propsOrganization ?? "");
	}, [propsOrganization, setOrganizationName]);

	const [isLoading, setIsLoading] = useState(false);
	const updateOrganization = useSignInContext().updateOrganization;

	const onSubmit = useCallback(async () => {
		const cleanOrganizationName = organizationName.trim();
		try {
			setIsLoading(true);
			await updateOrganization({ name: cleanOrganizationName });
			propsSetOrganization(cleanOrganizationName);
			navigateForwards();
		} catch {
			setIsLoading(false);
		}
	}, [
		setIsLoading,
		organizationName,
		updateOrganization,
		propsSetOrganization,
		navigateForwards,
	]);

	return (
		<OnboardingFrame
			title={t("onboarding.organization.title")}
			description={t("onboarding.organization.description")}
			buttonSecondary={{
				label: t("onboarding.organization.back"),
				onClick: navigateBackwards,
			}}
			buttonPrimary={{
				label: t("onboarding.organization.next"),
				onClick: onSubmit,
				disabled: isLoading || organizationName.trim().length === 0,
			}}
		>
			<VelavuInput
				value={organizationName}
				onChange={setOrganizationName}
				placeholder={t("onboarding.organization.placeholder")}
				fullWidth
			/>
		</OnboardingFrame>
	);
}
